// Site-wide SEO defaults — per-route values are set via utils/head.ts

export const SITE_URL = 'https://forgedevstack.com';
export const SITE_NAME = 'ForgeStack';
export const SITE_TITLE_SUFFIX = ' | ForgeStack';
export const DEFAULT_TITLE = 'ForgeStack — The open-source React & Node.js ecosystem';
export const DEFAULT_DESCRIPTION =
  'ForgeStack is an open-source ecosystem of React and Node.js libraries under @forgedevstack: Bear UI components, Grid Table data grid, forms, data fetching, state, routing, i18n, and the Harbor backend framework.';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/cover-hero.png`;
export const TWITTER_CARD_TYPE = 'summary_large_image';
export const ORGANIZATION_JSON_LD_ID = 'fs-jsonld-organization';
export const PAGE_JSON_LD_ID = 'fs-jsonld-page';
